<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<button-search class="pt-3" placeholder="货物名称" @search="searchEvent">
			<!-- 左边按钮 -->
			<template #left>
				<el-button type="primary" icon="el-icon-plus" size="mini"@click="navigate('zlgl_cpzl_cpgl_create')">添加</el-button>
				<el-button type="success" size="mini" icon="el-icon-receiving">导入数据</el-button>
			</template>
			<!-- 高级搜索 表单 -->
			<template #form>
				<el-form inline ref="form" :model="search" label-width="80px">
					<!-- 搜索内容 -->
					<el-form-item label="货物编号" class="mb-0">
						<el-input v-model="search.bh" size="mini" placeholder="货物编号"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="info" size="mini" @click="searchEvent">搜索</el-button>
						<el-button size="mini" @click="clearSearch">清空筛选条件</el-button>
					</el-form-item>
				</el-form>
		
			</template>
		</button-search>

		<!-- 头部标签页 -->
		<el-tabs v-model="tabIndex" @tab-click="getList" class="mt-2"><el-tab-pane :label="tab.name" :key="tabI" v-for="(tab, tabI) in tabbars"></el-tab-pane></el-tabs>

		<!-- 商品列表 -->
		<el-table :data="tableData" style="width: 100%;" @selection-change="handleSelectionChange" size="mini" key="table1" :max-height="maxHeight">
			<el-table-column align="center" prop="bh" width="90" label="编号" fixed="left"></el-table-column>
			<el-table-column prop="name" label="货物名称" width="300"></el-table-column>
			<el-table-column prop="zl" label="重量" width="170"></el-table-column>
			<el-table-column prop="mj" label="面积" width="170"></el-table-column>
			<el-table-column prop="tj" label="体积" width="170"></el-table-column>
			<el-table-column align="center" label="操作" fixed="right" width="180">
				<template slot-scope="scope">
					<el-button type="primary" size="mini" @click="navigate('zlgl_cpzl_cpgl_create',scope.row)">编辑</el-button>
					<el-button type="danger" size="mini" @click="deleteItem(scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;z-index: 100;width: 100%;margin-left: -20px;">
			<div style="flex: 1;" class="px-2">
				<el-pagination
					:current-page="page.current"
					:page-sizes="page.sizes"
					:page-size="page.size"
					layout="total, sizes, prev, pager, next, jumper"
					:total="page.total"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
				></el-pagination>
			</div>
		</el-footer>
	</div>
</template>

<script>
import common from '@/common/mixins/common.js';
import buttonSearch from '@/components/common/button-search.vue';
import { mapState } from 'vuex';
export default {
	mixins: [common],
	inject: ['layout'],
	components: {
		buttonSearch
	},
	data() {
		return {
			preUrl: 'cpgl',
			dialogId: 0,
			dialogVisible: false,
			dialogVisibles: false,
			tabIndex: 0,
			cklist:[],
			tabbars: [{ name: '全部货物', key: 'all' }],
			form: {
				// 表单值
				cpgl: {
					title: '',
					content: '' 
				}
			},
			tableData: [],
			maxHeight: 0,
			multipleSelection:[],
			createModel: false,
			vars:'',
			search: {
				keyword: "",
				bh:''
			},
		};
	},
	// 计算属性
	computed: {
		// 引入store-modules的user模块里面的user(存储用户相关的数据)
		...mapState({
			user: state => state.user.user
		}),
		// 订单类型
		tab() {
			return this.tabbars[this.tabIndex].key; //拿到key值，用来高级搜索
		},
		params() {
			let str = '';
			for (let key in this.form) {
				let val = this.form[key];
				if (val) {
					str += `&${key}=${this.form[key]}`;
				}
			}
			return str;
		}
	},
	created(){
		this.axios.get('/admin/cangkus', { token: true }).then(res => {
			this.cklist = res.data.data;
		});
	},
	mounted() {
		this.$nextTick(() => {
			this.maxHeight = window.innerHeight - 300; //300是页面中除了表格外其他组件的高度
		});
	},
	methods: {
		// 鼠标单击的事件
		navigate(name, e) {
			// 初始化表单
			if(!e){
				var data = {
					name:'',
					zl:800.0,
					bh:'自动生成',
					tj:2.0,
					mj:1.0
				}
			}else{
				var data = {
					id:e.id,
					bh:e.bh,
					name:e.name,
					zl:e.zl,
					tj:e.tj,
					mj:e.mj
				}
			}
			this.$router.push({
				name,
				params: { data }
			})
		},
		// 获取请求列表分页url
		getListUrl() {
			return `/admin/${this.preUrl}/${this.page.current}?limit=${this.page.size}&tab=${this.tab}&keyword=${this.search.keyword}&bh=${this.search.bh}`;
		},
		// 获取列表 可修改
		getListResult(e) {
			this.tableData = e.list
		},
		sckc(e){
			let i = {
				ckcw:this.vars,
				ids:e
			}
			console.log(i)
			this.axios.post('/admin/kcmxs', i,{
				token: true
			}).then(res => {
				this.getList()
			})
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		// 搜索事件
		searchEvent(e = false) {
			// 简单搜索
			if (typeof e === 'string') {
				this.search.keyword = e
				this.getList()
				return
			}
			// 高级搜索
			this.getList()
		},
		// 清空筛选条件
		clearSearch() {
			this.search = {
				keyword: "",
				bh: '',
			}
		},
	}
};
</script>

<style>
.el-collapse-item__header {
	/* display: flex; */
	align-items: center;
	height: 48px;
	line-height: 48px;
	margin-left: 10px;
	cursor: pointer;
	font-size: 13px;
	/* font-weight: 500; */
	transition: border-bottom-color 0.3s;
	outline: 0;
}
.demo-table-expand {
	font-size: 0;
}
.demo-table-expand label {
	width: 90px;
	color: #99a9bf;
}
.demo-table-expand .el-form-item {
	margin-right: 0;
	margin-bottom: 0;
	width: 50%;
}
.el-dropdown-link {
	cursor: pointer;
	color: #ff8c00;
}
.el-icon-arrow-down {
	font-size: 12px;
}
</style>
